export const myHobbiesData = [
  {
    id: 'omikgreoijnuwefrg',
    name: 'Desktop computer desk',
    paths: [
      {
        img: 'mesa/mesa-de-pinus-gamer.jpg',
        alt: 'Wooden computer desk on a black background'
      },
      {
        img: 'mesa/1.jpg',
        alt: 'Desk corner detail'
      },
      {
        img: 'mesa/estrutura-mesa-de-pinus-gamer.jpg',
        alt: 'Desk leg structure'
      },
      {
        img: 'mesa/estrutura-mesa-de-madeira.jpg',
        alt: '3D model of the desk metal structure'
      },
      {
        img: 'mesa/mesa-gamer-preta.jpg',
        alt: 'Desk in black version'
      },
      {
        img: 'mesa/5.jpg',
        alt: 'Wooden computer desk on a white background'
      },
    ],
    thumb: {
      white: 'mesa/mesa-gamer',
      alt: 'Gaming/office desk',
    },
    description: '<a href="https://www.behance.net/gallery/160692829/Mesa-Gamer" target="_blank">Behance</a>',
  },
  {
    id: 'qwrepotiurweq',
    name: 'Butterfly pendant',
    paths: [
      {
        img: 'butterfly/butterfly-black.jpg',
        alt: 'Butterfly pendant in transparent and gold version'
      },
      {
        img: 'butterfly/butterfly-white.jpg',
        alt: 'Model wearing the necklace'
      },
      {
        img: 'butterfly/colar-vermelho-3d.jpg',
        alt: 'Pendant in red version'
      },
      {
        img: 'butterfly/colar-dourado-de-borboleta.jpg',
        alt: 'Butterfly pendant in transparent and gold version'
      },
      {
        img: 'butterfly/colar-3d-modelagem.png',
        alt: '3D modeled butterfly necklace'
      },
    ],
    thumb: {
      white: 'butterfly/butterfly',
      alt: 'Butterfly necklace',
    },
    description: `<a href="https://www.behance.net/gallery/143019519/Necklace-Butterfly" target="_blank">Behance</a>`,
  },
  {
    id: 'asdkljghsadfkg',
    name: 'Mun',
    alt: 'Wall lamp, 3D modeling in Cinema 4D',
    paths: [
      {
        img: 'mun/mun_arandela_escamoteavel.jpg',
        alt: 'Retractable wall lamp (closed)'
      },
      {
        img: 'mun/mun-arandela-black.jpg',
        alt: 'Retractable wall lamp (closed)'
      },
      {
        img: 'mun/mun_visao_interna.jpg',
        alt: 'Retractable wall lamp (open)'
      },
      {
        img: 'mun/mun_visao_interna_escamoteavel.jpg',
        alt: 'Retractable wall lamp (open)'
      },
      {
        img: 'mun/mun_tag.jpg',
        alt: 'Product tag with the name Mun'
      },
      {
        img: 'mun/mun_Iluminacao.jpg',
        alt: 'Lighting variations of the lamp'
      },
      {
        img: 'mun/mun_area_de_iluminacao.jpg',
        alt: 'Moon phase lighting concept'
      },
    ],
    thumb: {
      white: 'mun/mun-arandela',
      alt: 'Retractable wall lamp'
    },
    description: `
      <b>Project portfolio</b>
      <p>Mun is a retractable wall lamp. The project was developed by me in collaboration with a three-person team. We drew inspiration from elements of Eastern culture and the phases of the moon. In this project, I was fully responsible for physical prototyping, 3D modeling, and rendering.</p>
      <br>
      <a href="https://www.behance.net/gallery/143187617/Luminaria-Mun-Redesign" target="_blank">Behance</a>
    `,
  },
  {
    id: '42390t4',
    name: '3D Render | DKNY Wristwatch',
    alt: '3D Render | DKNY Wristwatch',
    paths: [
      {
        img: 'relogio/clock_1.jpg',
        alt: 'DKNY 3D render'
      },
      {
        img: 'relogio/clock_3.jpg',
        alt: 'DKNY 3D render'
      },
      {
        img: 'relogio/clock-white.jpg',
        alt: 'DKNY 3D render'
      },
      {
        img: 'relogio/clock-black.jpg',
        alt: 'DKNY 3D render'
      },
    ],
    thumb: {
      white: 'relogio/clock',
      alt: 'DKNY 3D render'
    },
    description: `<a href="https://www.behance.net/gallery/131660875/DKNY-MODELAGEM" target="_blank">Behance</a>`,
  },
]